import granada81 from "./granada8-1.webp";
import granada82 from "./granada8-2.webp";

const granada8 = [granada81, granada82];

export default granada8;
